'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, i = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, i = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
const GridContainer = renderWithRef('GridContainer', null, (t, s)=>{
    useDeprecatedProps('GridContainer', t, [
        {
            propName: 'gutter',
            instructions: 'As it is rarely used, it has been deprecated to improve consistency for customers, and reduce UX debt.'
        }
    ]);
    let { children: p, dividers: a = false, gutter: c = 'standard' } = t, d = _object_without_properties(t, [
        "children",
        "dividers",
        "gutter"
    ]);
    useComponentStylesLoaded('GridContainer', SWAN_STYLE_KEY_MAP.grid);
    let u = [
        'swan-grid-container'
    ];
    return a && u.push('swan-grid-dividers'), 'tight' === c && u.push('swan-grid-container-tight'), jsx(RenderComp, {
        root: "div",
        forwardedRef: s,
        props: d,
        classNames: u,
        children: p
    });
});

export { GridContainer };
